import { render, staticRenderFns } from "./AutomaticQuestionnaire.vue?vue&type=template&id=12513458&scoped=true&"
import script from "./AutomaticQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./AutomaticQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./AutomaticQuestionnaire.vue?vue&type=style&index=0&id=12513458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12513458",
  null
  
)

export default component.exports